import API from './index';
import '../helpers';
import moment from 'moment';

function getQuestions (params) {
	const options = {
		method: 'GET',
		headers: {
			'auth-token': `${params.authToken}`
		}
	};
	//const endPoint = '/questions/by/' + params.data.interventionType.toLowerCase()
	// const endPoint = '/questions/by/assessment'
	return API.get('/questions/by/' + params.interventionType.toLowerCase(), options)
		.then((response) => {
			return response;
		})
		.catch((error) => {
			return error;
		});
}

function postAnswers (params) {
	// console.log('\npost answers\n', params, params.authToken);
	const data = {
		answers: params.answers,
		type: params.type,
		session_start: moment(params.startDate).format('YYYY-MM-DD HH:mm:ss'),
		session_end: moment(params.endDate).format('YYYY-MM-DD HH:mm:ss'),
		phase: params.phase,
		timeSpent: params.timeSpent
	};
	const options = {
		method: 'POST',
		headers: {
			'auth-token': `${params.authToken}`
		}
	};
	return API.post('/questions', data, options)
		.then((response) => {
			// console.log('response in api: \n', response);
			return response;
		})
		.catch((error) => {
			// console.log('error in api: \n', error.response);
			throw error.response;
		});
}

export const questionsService = {
	getQuestions,
	postAnswers,
};
